/**
 * 날짜는 사용자의 현지 날짜로 다룬다. toISOString()은 UTC라 한국 시간 오전 9시 전에는 하루 전 날짜가 된다.
 */
const p = (n: number) => String(n).padStart(2, '0');

export function localDate(d: Date = new Date()): string {
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** ISO 시각(UTC) → 현지 날짜 */
export function localDateOf(iso: string): string {
  return localDate(new Date(iso));
}
